$(function () {

    if ($('.saved_products_list__main_section__product_list').length < 1) {
        return;
    }

    $('.saved_products_list__main_section__product_list').align({
        selector: '.site_card *'
    });

});